import type { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useLinkButtonStyles = makeStyles((theme: Theme) => ({
    link: {
        cursor: "pointer",
        fontSize: 12,
        color: theme.palette.textGrey.main,
        userSelect: "none",
        "&:hover": {
            textDecoration: "underline",
            color: theme.palette.primary.main,
        },
    },
    disabled: {
        pointerEvents: "none",
        opacity: "0.38",
    },
}));
